import { Instagram, Youtube, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";

// Awaiting the real profile URLs from the client. Until then nothing is rendered,
// rather than shipping dead links.
const SOCIALS = [
  { Icon: Instagram, label: "Gary Malkin Enterprises on Instagram", href: "" },
  { Icon: Youtube, label: "Gary Malkin Enterprises on YouTube", href: "" },
  { Icon: Linkedin, label: "Gary Malkin Enterprises on LinkedIn", href: "" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative pt-16 pb-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12 mb-14">
          <div>
            <img loading="lazy" src="/assets/logos/gme-horizontal-white.webp" alt="Gary Malkin Enterprises" className="h-14 w-auto mb-5" />
            <p className="font-serif italic text-lg text-[#E7CC86] mb-3">Sound wisdom for a humane and compassionate world.</p>
            <p className="text-cream/50 text-sm max-w-sm leading-relaxed">
              Cultivating Resonance Intelligence through ideas, shared experiences, musical catalysts, and immersive media—for more human ways of living, leading, creating, and contributing.
            </p>
          </div>

          <div>
            <h3 className="text-cream font-semibold mb-4 tracking-wide">Explore</h3>
            <ul className="space-y-2.5 text-cream/60 text-[15px]">
              <li><Link to="/story" className="hover:text-[#E7CC86] transition-colors">Gary's Story</Link></li>
              <li><Link to="/work/yourself" className="hover:text-[#E7CC86] transition-colors">The Work</Link></li>
              <li><Link to="/listen" className="hover:text-[#E7CC86] transition-colors">Listen</Link></li>
              <li><Link to="/portals-of-awe" className="hover:text-[#E7CC86] transition-colors">Portals of Awe</Link></li>
              <li><Link to="/world" className="hover:text-[#E7CC86] transition-colors">Gary's World</Link></li>
              <li><Link to="/wisdom-keepers" className="hover:text-[#E7CC86] transition-colors">Wisdom Keepers</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-cream font-semibold mb-4 tracking-wide">Connect</h3>
            {/* Social links render only once a real URL exists. They previously shipped as
                href="#", which is a dead link with no accessible name — three per page,
                site-wide. Add the URLs here and the icons come back automatically. */}
            {SOCIALS.filter((sn) => sn.href).length > 0 && (
              <div className="flex gap-3 mb-6">
                {SOCIALS.filter((sn) => sn.href).map(({ Icon, href, label }) => (
                  <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
                    className="w-10 h-10 rounded-full border border-[#C9A24B]/30 flex items-center justify-center text-[#E7CC86] hover:bg-[#C9A24B]/10 hover:border-[#C9A24B] transition-all">
                    <Icon size={18} aria-hidden="true" />
                  </a>
                ))}
              </div>
            )}
            <p className="text-cream/50 text-sm">Writing &amp; reflections on Substack — coming soon.</p>
          </div>
        </div>

        <div className="gold-hairline mb-6" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-5">
          <p className="text-cream/40 text-sm">© {new Date().getFullYear()} Gary Malkin Enterprises. All rights reserved.</p>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            <Link to="/privacy-policy" data-testid="footer-privacy" className="text-cream/45 text-sm hover:text-[#E7CC86] transition-colors">Privacy Policy</Link>
            <Link to="/cookie-policy" data-testid="footer-cookie" className="text-cream/45 text-sm hover:text-[#E7CC86] transition-colors">Cookie Policy</Link>
          </div>
        </div>
        <p className="text-cream/25 text-xs mt-6 max-w-3xl leading-relaxed">
          By providing your information you consent to receive email and SMS communications from Gary Malkin Enterprises.
          Message and data rates may apply. Reply STOP to unsubscribe. You may opt out at any time.
        </p>
      </div>
    </footer>
  );
};
